import React from 'react';
import { Zap } from 'lucide-react';

const BoldFooter = () => {
  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-6" style={{paddingTop: '63px', paddingBottom: '48px'}}>
        <div className="grid md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-r from-electric-blue to-neon-green rounded-xl flex items-center justify-center mr-3">
                  <Zap className="w-6 h-6 text-white" />
                </div>
              </div>
              <span className="text-xl font-black text-white uppercase tracking-wide">
                COACH<span className="text-neon-green">AI</span>
              </span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Empowering personal transformation through intelligent AI coaching.
            </p>
          </div>

          {/* Product & Support Links - Right Side */}
          <div className="grid grid-cols-2 gap-6 md:justify-end">
            {/* Product Links */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-3">PRODUCT</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-neon-green transition-colors text-sm">Features</a></li>
                <li><a href="#" className="text-gray-400 hover:text-neon-green transition-colors text-sm">Pricing</a></li>
                <li><a href="#" className="text-gray-400 hover:text-neon-green transition-colors text-sm">Mobile App</a></li>
              </ul>
            </div>

            {/* Support Links */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-3">SUPPORT</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-electric-blue transition-colors text-sm">Help Center</a></li>
                <li><a href="#" className="text-gray-400 hover:text-electric-blue transition-colors text-sm">Contact Us</a></li>
                <li><a href="#" className="text-gray-400 hover:text-electric-blue transition-colors text-sm">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 COACHAI. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-3 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-neon-green transition-colors text-sm">Privacy</a>
            <a href="#" className="text-gray-400 hover:text-electric-blue transition-colors text-sm">Terms</a>
            <a href="#" className="text-gray-400 hover:text-neon-green transition-colors text-sm">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BoldFooter;